import { render, staticRenderFns } from "./DadataCustom.vue?vue&type=template&id=00210df2"
import script from "./DadataCustom.vue?vue&type=script&lang=js"
export * from "./DadataCustom.vue?vue&type=script&lang=js"
import style0 from "./DadataCustom.vue?vue&type=style&index=0&id=00210df2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports